import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, showMessageToast } from '../../../../utils/util';
import { Input, BackButton, Button, ListPagination, Select, SelectResource, Modal, Collapsible } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import PrintLabelListItem from './PrintLabelListItem'
import { ENUMS, VISIONS } from '../../../../utils/constants';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import { getVision } from '../../../../services/auth';

const PrintLabelList = (props) => {
    const [openModal, setOpenModal] = useStateWithPromise(false);
    const [item, setItem] = useStateWithPromise();
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            partnumbercode: undefined,
            invoice: undefined,
            journey: undefined,
            cim: undefined,
            mastercim: undefined,
            createOn: undefined,
            success: undefined
        });
    const [labels, setLabels] = useState([]);

    useEffect(() => {
        getLabels();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.labels?.items?.length > 0) {
            if (labels.length > 0 && currentPage === 0) {
                setLabels(props.labels.items);
            } else {
                setLabels((prevState) => ([...prevState, ...props.labels.items]));
            }
        } else {
            setLabels([]);
        }
        // eslint-disable-next-line
    }, [props?.labels?.items]);

    useEffect(() => {
        getLabels();
        // eslint-disable-next-line
    }, [currentPage]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const getLabels = () => {
        props.getLabels({
            ...filter,
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        })
    }

    const onClick = () => {
        setCurrentPage(0);
        getLabels();
    }

    const onClickItem = () => {
        let printer = props.user.printer;
        if (!printer) {
            return showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
        }
        props.reprintLabel({
            Id: item.id,
            printer: printer
        })
        setItem();
    }

    const renderSelectResource = () => {
        return (
            <div id="renderSelectResource" className='row'>
                <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '10px' }}>
                    <div className="input-field col s12">
                        <SelectResource
                            loadConfigLaser={getVision() === VISIONS.Jeep}
                            required
                            name="resource"
                            id="resource"
                            value={props.user?.resource} />
                    </div>
                    <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
                        {translate('message-report-print', 'physical-confirmation')}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <Collapsible
                        id="collapsible"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <>
                                <form id="filterReport" className='row' style={{ marginBottom: '20px' }} >
                                    <div className="input-field no-padding col s12 m5" >
                                        <Input
                                            id="partnumbercode"
                                            name='partnumbercode'
                                            label={translate("part-number", 'physical-confirmation')}
                                            type="text"
                                            defaultValue={filter?.partnumber || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12 m5">
                                        <Input
                                            id="invoice"
                                            name='invoice'
                                            label={translate("invoice", 'physical-confirmation')}
                                            type="text"
                                            defaultValue={filter?.invoice || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12 m5">
                                        <Input
                                            id="journey"
                                            name='journey'
                                            label={translate("journey", 'physical-confirmation')}
                                            type="text"
                                            defaultValue={filter?.journey || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12 m5">
                                        <Input
                                            id="cim"
                                            name='cim'
                                            label={translate("cim", 'physical-confirmation')}
                                            type="text"
                                            maxLength={10}
                                            defaultValue={filter?.cim || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12 m5">
                                        <Input
                                            id="mastercim"
                                            name='mastercim'
                                            label={translate("mastercim", 'physical-confirmation')}
                                            type="text"
                                            defaultValue={filter?.mastercim || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12 m5">
                                        <Input
                                            id="cimpallet"
                                            name='cimpallet'
                                            label={translate("cimpallet", 'physical-confirmation')}
                                            type="text"
                                            defaultValue={filter?.cimpallet || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12 m5">
                                        <Input
                                            id="createOn"
                                            name='createOn'
                                            label={translate("generation-date", 'physical-confirmation')}
                                            type="date"
                                            defaultValue={filter?.createOn || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="no-padding col s12 m5">
                                        <Select
                                            id="success"
                                            name="success"
                                            change={onChange}
                                            defaultValue={filter?.success || ''}

                                            placeHolder={`Status - ${translate('general:choose-one-option')}`}
                                            data={[
                                                { id: true, text: translate("only-success", 'physical-confirmation') },
                                                { id: false, text: translate("only-failure", 'physical-confirmation') }
                                            ]}
                                        />
                                    </div>
                                </form>
                                <div className="row" >
                                    <Button
                                        full="true"
                                        text={translate('search', 'general')}
                                        onClick={() => onClick()}
                                    />
                                </div>
                            </>
                        }
                    />
                </div>
            </div>
            {labels && (
                <div className="container-fluid container" style={{ marginTop: '60px' }}>
                    <ListPagination
                        page={props.labels?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={labels.map((item, index) => {
                            return (
                                <PrintLabelListItem key={`key_${index}`} onClickItem={item => setItem(item).then(() => {
                                    setOpenModal(true)
                                })} item={item} />
                            );
                        })}
                    />
                </div>
            )}
            <Modal
                open={openModal}
                id="modalPrintLocation"
                content={'Imprimir Etiqueta'}
                children={renderSelectResource()}
                dismissible={false}
                onConfirm={() => {
                    onClickItem();
                    setOpenModal(false)
                }}
                closeModal={() => {
                    setOpenModal(false);
                    setItem()
                }}
                btnConfirm="Enviar Impressora"
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        labels: state.physicalConfirmationReducer.labels,
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLabels: (filter, callback) => {
            dispatch(ChangeLocationService.getLabels(filter, callback));
        },
        reprintLabel: (data) => {
            dispatch(ChangeLocationService.reprintLabel(data));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PrintLabelList)));
